import {Typography} from "@project/design-system-web";
import {useRouter} from "@tanstack/react-router";

interface AppErrorBoundaryProps {
  error: Error;
  reset: () => void;
}

/**
 * Root-level error boundary component for TanStack Router.
 */
export function AppErrorBoundary({error, reset}: AppErrorBoundaryProps) {
  const router = useRouter();

  function handleReset() {
    // Invalidate the router state so that the next navigation re-runs loaders.
    void router.invalidate();
    reset();
  }

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <Typography type="h1" className="text-foreground text-2xl font-bold">
        Something went wrong
      </Typography>
      <Typography className="text-foreground/60 max-w-md text-sm">{error.message}</Typography>
      <button
        className="bg-primary text-primary-foreground rounded-md px-4 py-2 text-sm font-medium"
        onClick={handleReset}
        type="button"
      >
        Try again
      </button>
    </div>
  );
}
